import React from 'react'
import { SwiperSlide } from 'swiper/react'
import styled from 'styled-components'

import Carousel from 'components/Carousel'

import { removeScriptTags } from 'helpers/formatters'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

import { SiteMessageDetail } from 'types/SiteMessageDetail'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

type Props={
  title: string
  siteMessages: Array<SiteMessageDetail>
  finishCallback: () => void
}

const FeatureTourCarousel = ({ title, siteMessages, finishCallback }: Props) => {
  return (
    <Carousel finishCallback={finishCallback} >
      { siteMessages.map((siteMessage) => (
        <SwiperSlide key={siteMessage.id}>
          <S.Container>
            {siteMessage.image && <S.Image src={siteMessage.image} /> }
            <S.SiteMessageDetail>
              <div>
                <S.Heading>{title}</S.Heading>
                <h2>{siteMessage.title}</h2>
                <br />
                <br />
                <a href={siteMessage.actionButtonLink} target="_blank" rel="noopener noreferrer">
                  <Button decoration="secondary" text={siteMessage.actionButtonCaption} />
                </a>
              </div>
              <div>
                <S.Message dangerouslySetInnerHTML={{ __html: removeScriptTags(siteMessage.message) }} />
              </div>
            </S.SiteMessageDetail>
          </S.Container>
        </SwiperSlide>
      )
      )}
    </Carousel>
  )
}

export default FeatureTourCarousel

const S = {
  Container: styled.div`
    padding: 20px;
    width: 100%;
  `,
  Heading: styled.h2`
    color: ${color('featureToursHeading')};
    margin-top: 25px;
  `,
  SiteMessageDetail: styled.div`
    display: flex;
    text-align: left;
    gap: 10px;
    & > * {
      width: 50%;
    }
    @media ${screenSize.small} {
      flex-direction: column;

       & > * {
        width: 100%;
      }
    }
  `,
  Image: styled.img`
    width: 100%;
  `,
  Message: styled.p`
    color: ${color('primaryText')};
    font-size: 16px;
    line-height: 1.5;
  `,
  Link: styled.a`
    color: ${color('featureToursSiteLink')};
  `
}
